module.exports = "/_next/static/images/8f905ddbc3dec9805042a4a6ea8d786c-defer-lg.png";